<template>
  <li :class="{active:tab.active}">
    <a href="javascript:void(0)" :class="{disabled: !tab.checked}">
      <div class="wizard-icon-circle md"
          role="tab"
          :tabindex="tab.checked ? 0 : ''"
          :id="`step-${tab.tabId}`"
          :aria-controls="tab.tabId"
          :aria-disabled="tab.active"
          :aria-selected="tab.active"
          :class="{ checked: tab.checked, square_shape: isStepSquare, tab_shape: isTabShape }"
          :style="stepStyle">

        <transition :name="transition" mode="out-in">
          <div v-if="tab.active" class="wizard-icon-container"
              :class="{square_shape:isStepSquare, tab_shape:isTabShape}"
              :style="[ tab.active ? iconActiveStyle : {}, tab.validationError ? errorStyle : {} ]">
            <slot name="active-step">
              <span v-if="tab.icon" class="wizard-icon">
                <i class="mdi mdi-24px" :class="iconClass"></i>
              </span>
            </slot>
          </div>
          <slot v-if="!tab.active">
            <span v-if="!tab.active && tab.checked" class="wizard-icon">
              <i class="mdi mdi-check mdi-36px"></i>
            </span>
          </slot>
        </transition>

      </div>
      <slot name="title">
        <span class="stepTitle"
              :class="{ active: tab.active, has_error: tab.validationError }"
              :style="tab.active ? stepTitleStyle : {}">
              {{tab.title}}
        </span>
      </slot>
    </a>
  </li>
</template>
<script>
  export default {
    name: 'form-step',
    props: {
      tab: {
        type: Object,
        default: () => {}
      },
      transition: {
        type: String,
        default: ''
      },
      index: {
        type: Number,
        default: 0
      }
    },
    computed: {
      iconClass () {
        let classes = {}
        const className = `mdi-${this.tab.icon}`
        classes[className] = this.tab.icon

        return classes
      },
      iconActiveStyle () {
        return {
          backgroundColor: '#FFF',
          borderRadius: '50%'
        }
      },
      stepActiveStyle () {
        return {
          borderColor: this.tab.color,
          borderWidth: '0.5rem'
        }
      },
      stepInactiveStyle () {
        return {
          color: 'rgb(79, 77, 72)',
          borderColor: 'rgb(172, 172, 172)',
          backgroundColor: 'rgb(172, 172, 172)'
        }
      },
      errorStyle () {
        return {
          borderColor: this.tab.errorColor,
          backgroundColor: this.tab.errorColor
        }
      },
      stepStyle () {
        return [
          this.tab.active ? this.stepActiveStyle : this.stepInactiveStyle,
          this.tab.validationError ? this.errorStyle : {}
        ]
      },
      stepTitleStyle () {
        let isError = this.tab.validationError
        return {
          color: isError ? this.tab.errorColor : this.tab.color
        }
      },
      isStepSquare () {
        return this.tab.shape === 'square'
      },
      isTabShape () {
        return this.tab.shape === 'tab'
      }
    }
  }
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/components/shared/FormStep.vue